// extracted by mini-css-extract-plugin
export var marginNegative = "_7d-5 _7d-3 _7d-1";
export var marginPositive = "_7d-4 _7d-3 _7d-1";
export var modalContent = "_7d-6";
export var samplesTable = "_7d-8";
export var samplesTableContainer = "_7d-7";
export var statBox = "_7d-a";
export var tableCell = "_7d-1";
export var tableCellCenter = "_7d-2 _7d-1";
export var tableCellRight = "_7d-3 _7d-1";
export var tableHeader = "_7d-0";
export var trackingNumber = "_7d-9";